export const baseStyles = {
  container: {
    maxWidth: '600px', // Mobile optimized width
    margin: '0 auto',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    paddingBottom: 'calc(80px + env(safe-area-inset-bottom))', // Dynamic safe-area padding for mobile navigation bars
    position: 'relative',
  },
  header: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    zIndex: 10,
    padding: '15px 20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    margin: 0,
    fontSize: '20px',
    fontWeight: '800',
    color: '#333',
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  versionBadge: {
    fontSize: '12px',
    padding: '2px 8px',
    borderRadius: '10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.3s ease',
  },
  exportBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '6px 12px',
    backgroundColor: '#eee',
    border: 'none',
    borderRadius: '20px',
    cursor: 'pointer',
  },
  searchBar: {
    padding: '10px 20px',
    backgroundColor: '#fff',
    borderBottom: '1px solid #eee',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  filterGroup: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flex: 1,
  },
  searchForm: {
    display: 'flex',
    flex: 1,
    gap: '5px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    padding: '0 15px',
    alignItems: 'center',
  },
  searchInput: {
    flex: 1,
    padding: '10px 15px',
    borderRadius: '20px',
    border: '1px solid #ddd',
    fontSize: '14px',
    backgroundColor: '#f5f5f5',
    outline: 'none',
  },
  searchBtn: {
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterContainer: {
    padding: '10px 20px',
    backgroundColor: '#fff',
    borderBottom: '1px solid #eee',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  filterRow: {
    display: 'flex',
    gap: '10px',
    overflowX: 'auto',
    paddingBottom: '5px',
    scrollbarWidth: 'none', // Hide scrollbar Firefox
  },
  filterSelect: {
    padding: '8px 12px',
    borderRadius: '15px',
    border: '1px solid #ddd',
    fontSize: '13px',
    backgroundColor: '#fff',
    minWidth: '100px',
    appearance: 'none', // Remove default arrow
  },
  filterStatus: {
    fontSize: '12px',
    color: '#888',
    marginTop: '5px',
    textAlign: 'right'
  },
  filterPanel: {
    backgroundColor: '#f9f9f9',
    padding: '15px',
    borderRadius: '15px',
    marginBottom: '20px',
  },
  filterInput: {
    flex: 1,
    minWidth: '120px',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    boxSizing: 'border-box',
  },
  resetBtn: {
    padding: '8px 12px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#666',
    color: '#fff',
    fontSize: '12px',
    cursor: 'pointer',
  },
  itemList: {
    padding: '15px',
  },
  itemCard: {
    backgroundColor: '#fff',
    borderRadius: '15px',
    padding: '15px',
    marginBottom: '15px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    transition: 'transform 0.2s',
  },
  itemThumbnail: {
    width: '60px',
    height: '60px',
    borderRadius: '10px',
    objectFit: 'cover',
    backgroundColor: '#eee',
  },
  thumbnailContainer: {
    position: 'relative',
    cursor: 'pointer',
  },
  itemInfo: {
    flex: 1,
  },
  itemName: {
    margin: '0 0 5px 0',
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
  },
  itemDetail: {
    margin: 0,
    fontSize: '13px',
    color: '#666',
  },
  categoryBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    fontSize: '11px',
    fontWeight: 'bold',
    marginRight: '6px',
  },
  actionBtns: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  gridActionPill: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    zIndex: 3,
    display: 'flex',
    gap: '6px',
    padding: '4px',
    borderRadius: '999px',
    backgroundColor: 'rgba(255,255,255,0.85)',
    border: '1px solid rgba(0,0,0,0.06)',
    backdropFilter: 'blur(6px)',
  },
  gridOverlayQtyBadge: {
    position: 'absolute',
    left: '8px',
    bottom: '8px',
    zIndex: 2,
    padding: '2px 8px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 800,
    backgroundColor: 'rgba(255,255,255,0.9)',
    border: '1px solid rgba(0,0,0,0.08)',
    color: '#111',
    backdropFilter: 'blur(6px)',
  },
  editBtn: {
    border: 'none',
    background: 'none',
    color: '#aaa',
    cursor: 'pointer',
    padding: '5px',
  },
  deleteBtn: {
    border: 'none',
    background: 'none',
    color: '#ff4d4d',
    cursor: 'pointer',
    padding: '5px',
  },
  emptyMsg: {
    textAlign: 'center',
    color: '#999',
    marginTop: '50px',
    fontSize: '14px',
  },
  retryBtn: {
    padding: '10px 20px',
    backgroundColor: '#fff',
    color: '#000',
    border: 'none',
    borderRadius: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    borderTop: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-end', // Align items to bottom
    padding: '10px 0 calc(15px + env(safe-area-inset-bottom)) 0', // Dynamically adjust spacing under Android navigation keys
    zIndex: 100,
    maxWidth: '600px', // Match container width
    margin: '0 auto', // Center if container is centered
  },
  navItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#666',
    cursor: 'pointer',
    width: '50px',
  },
  activeNavItem: {
    color: '#000',
  },
  fabContainer: {
    position: 'relative',
    top: '-20px',
  },
  fab: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    cursor: 'pointer',
  },
  
  // Camera & Registration Styles
  cameraOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#000',
    zIndex: 200,
    display: 'flex',
    flexDirection: 'column',
  },
  cameraHeader: {
    padding: '15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#fff',
    zIndex: 201,
  },
  iconBtn: {
    background: 'none',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    padding: '5px',
  },
  webcamContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  webcam: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    textAlign: 'center',
    color: '#fff',
  },
  errorText: {
    margin: '20px 0',
    fontSize: '16px',
    lineHeight: '1.5',
    textAlign: 'left',
    backgroundColor: 'rgba(255,255,255,0.1)',
    padding: '15px',
    borderRadius: '10px',
  },
  cameraFooter: {
    padding: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#000',
  },
  captureBtn: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    border: '4px solid #fff',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  captureBtnInner: {
    width: '54px',
    height: '54px',
    borderRadius: '50%',
    backgroundColor: '#fff',
  },
  infoOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#fff',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
  },
  previewContainer: {
    height: '30%',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: '#000',
  },
  previewImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  rotateBtn: {
    position: 'absolute',
    bottom: '15px',
    right: '15px',
    backgroundColor: 'rgba(0,0,0,0.6)',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    width: '44px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  },
  fullForm: {
    padding: '20px',
    flex: 1,
    overflow: 'auto',
  },
  inputGroup: {
    marginBottom: '20px',
  },
  fullInput: {
    width: '100%',
    padding: '15px 0',
    border: 'none',
    borderBottom: '2px solid #eee',
    fontSize: '18px',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
  },
  finishBtn: {
    margin: '20px',
    padding: '15px',
    backgroundColor: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '15px',
    fontSize: '18px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    cursor: 'pointer',
  },
  cameraView: {
    flex: 1,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  captureControls: {
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '40px',
    backgroundColor: 'rgba(0,0,0,0.5)',
    paddingBottom: '20px',
  },
  shutterBtn: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    border: '4px solid rgba(255,255,255,0.3)',
    cursor: 'pointer',
  },
  
  // Form Styles
  formContainer: {
    padding: '20px',
    backgroundColor: '#fff',
    minHeight: '100vh',
  },
  formGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: '600',
    fontSize: '14px',
    color: '#555',
  },
  input: {
    width: '100%',
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid #ddd',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box', // Ensure padding doesn't increase width
  },
  submitBtn: {
    width: '100%',
    padding: '15px',
    backgroundColor: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '15px',
    fontSize: '16px',
    fontWeight: 'bold',
    marginTop: '20px',
    cursor: 'pointer',
  },
  imagePreview: {
    width: '100%',
    height: '200px',
    objectFit: 'contain',
    backgroundColor: '#000',
    borderRadius: '10px',
    marginBottom: '20px',
  },

  // Modal
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.9)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  modalContent: {
    position: 'relative',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  fullImage: {
    maxWidth: '100%',
    maxHeight: '90vh',
    objectFit: 'contain',
  },
  closeModalBtn: {
    position: 'absolute',
    top: '-40px',
    right: 0,
    background: 'none',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
  },

  settingsPanel: {
    position: 'absolute',
    top: '60px',
    right: '20px',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    padding: '20px',
    borderRadius: '10px',
    zIndex: 1001,
    width: '280px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.5)',
    border: '1px solid #444',
  },
  settingsTitle: {
    margin: '0 0 15px 0',
    color: '#fff',
    fontSize: '18px',
    textAlign: 'center',
  },
  settingGroup: {
    marginBottom: '15px',
  },
  settingLabel: {
    display: 'block',
    color: '#ccc',
    marginBottom: '8px',
    fontSize: '14px',
  },
  settingSelect: {
    width: '100%',
    padding: '8px',
    borderRadius: '5px',
    border: '1px solid #555',
    backgroundColor: '#222',
    color: '#fff',
    fontSize: '14px',
  },
  resButtons: {
    display: 'flex',
    gap: '8px',
  },
  resBtn: {
    flex: 1,
    padding: '8px 0',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  closeSettingsBtn: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#444',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    marginTop: '10px',
    cursor: 'pointer',
  },
  gridCard: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: '1px solid #eee',
  },
  gridMedia: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#f0f0f0',
  },
  gridMediaImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  gridMeta: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    flex: 1,
    minHeight: 0,
  },
  gridMetaTop: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    alignItems: 'flex-start',
  },
  gridQtyBadge: {
    fontWeight: 'bold',
    backgroundColor: '#eee',
    padding: '2px 8px',
    borderRadius: '999px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    alignSelf: 'flex-start',
  },
  gridActions: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    display: 'flex',
    gap: '8px',
    zIndex: 2,
  },
  gridActionBtn: {
    width: '34px',
    height: '34px',
    borderRadius: '999px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.9)',
    backdropFilter: 'blur(6px)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  gridPillRow: {
    display: 'flex',
    gap: '6px',
    flexWrap: 'wrap',
    alignItems: 'center',
    minHeight: '18px',
  },
  gridTagPill: {
    fontSize: '10px',
    backgroundColor: '#eee',
    padding: '2px 6px',
    borderRadius: '6px',
    color: '#666',
  },
};

export const getThemeStyles = (darkMode) => {
  if (!darkMode) return baseStyles;

  return {
    ...baseStyles,
    container: {
      ...baseStyles.container,
      backgroundColor: '#1a1a1a',
      color: '#eee',
    },
    header: {
      ...baseStyles.header,
      backgroundColor: '#1a1a1a', // Fixed header color match
      borderBottom: '1px solid #333',
    },
    title: {
      ...baseStyles.title,
      color: '#fff',
    },
    itemCard: {
      ...baseStyles.itemCard,
      backgroundColor: '#2a2a2a',
      border: '1px solid #333',
    },
    itemName: {
      ...baseStyles.itemName,
      color: '#fff',
    },
    itemDetail: {
      ...baseStyles.itemDetail,
      color: '#aaa',
    },
    bottomNav: {
      ...baseStyles.bottomNav,
      backgroundColor: '#1a1a1a',
      borderTop: '1px solid #333',
    },
    navItem: {
      ...baseStyles.navItem,
      color: '#aaa',
    },
    activeNavItem: {
      color: '#fff',
    },
    filterPanel: {
      ...baseStyles.filterPanel,
      backgroundColor: '#2a2a2a',
    },
    searchBar: {
      ...baseStyles.searchBar,
      backgroundColor: '#1a1a1a',
      borderBottom: '1px solid #333',
    },
    searchForm: {
      ...baseStyles.searchForm,
      backgroundColor: '#333',
    },
    searchInput: {
      ...baseStyles.searchInput,
      backgroundColor: '#444',
      border: '1px solid #555',
      color: '#fff',
    },
    filterContainer: {
        ...baseStyles.filterContainer,
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
    },
    filterSelect: {
        ...baseStyles.filterSelect,
        backgroundColor: '#333',
        color: '#fff',
        border: '1px solid #444',
    },
    // Grid Cards Dark Mode
    gridCard: {
        ...baseStyles.gridCard,
        backgroundColor: '#2a2a2a',
        border: '1px solid #333',
    },
    gridMedia: {
        ...baseStyles.gridMedia,
        backgroundColor: '#333',
    },
    gridMetaTop: {
        ...baseStyles.gridMetaTop,
        color: '#fff',
    },
    gridTagPill: {
        ...baseStyles.gridTagPill,
        backgroundColor: '#444',
        color: '#ccc',
    },
    gridQtyBadge: {
        ...baseStyles.gridQtyBadge,
        backgroundColor: '#444',
        color: '#fff',
    }
  };
};
